import { render, staticRenderFns } from "./MenuVendaRecebimento.vue?vue&type=template&id=1dd601f8&scoped=true&"
import script from "./MenuVendaRecebimento.vue?vue&type=script&lang=js&"
export * from "./MenuVendaRecebimento.vue?vue&type=script&lang=js&"
import style0 from "./MenuVendaRecebimento.vue?vue&type=style&index=0&id=1dd601f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd601f8",
  null
  
)

export default component.exports